<template>
  <div style="min-height: 500px">
    <div v-if="loading" v-masonry transition-duration="0" item-selector=".item">
      <ListItem
        v-masonry-tile
        class="item"
        v-for="n in 3"
        :key="'loading-' + n"
        :item="null"
      />
    </div>
    <div v-else v-masonry transition-duration="0" item-selector=".item">
      <ListItem
        v-masonry-tile
        class="item"
        v-for="item in items"
        :key="item.id"
        :item="item"
      />
    </div>
    <div class="nodata" v-show="nodata">Мэдээлэл алга</div>
    <div class="text-center" v-show="morebtn" @click="onmore">
      <b-btn class="loadmore" variant="primary" size="sm" v-if="!moreLoading"
        >Цааш нь ...</b-btn
      >
      <orbit-spinner
        :animation-duration="1200"
        :size="40"
        :color="'#0d8285'"
        v-else
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { VueMasonryPlugin } from "vue-masonry";
import ListItem from "./ListItem";
import { OrbitSpinner } from "epic-spinners";

Vue.use(VueMasonryPlugin);

export default {
  components: {
    OrbitSpinner,
    ListItem
  },
  props: ["api", "preitems"],
  data() {
    return {
      items: [],
      loading: true,
      nodata: false,
      morebtn: false,
      pred: false,
      moreLoading: false
    };
  },
  methods: {
    reload() {
      this.loading = true;
      this.nodata = false;
      this.items = [];

      this.api(this.$route.params.slug, null).then(response => {
        this.loading = false;
        if (response.data.status === "success") {
          this.morebtn = response.data.data.length > 9;
          this.items = response.data.data;
        } else {
          this.nodata = true;
          this.morebtn = false;
          // console.log(response.data.message);
        }
      });
    },
    onmore() {
      this.moreLoading = true;
      this.api(
        this.$route.params.slug,
        this.items[this.items.length - 1].cdate
      ).then(response => {
        this.moreLoading = false;
        if (response.data.status === "success") {
          this.morebtn = response.data.data.length > 9;
          this.items = this.items.concat(response.data.data);
        } else {
          this.nodata = true;
          this.morebtn = false;
          // console.log(response.data.message);
        }
      });
    }
  },
  mounted() {
    this.reload();
  },
  watch: {
    $route() {
      this.reload();
    },
    preitems(val) {
      if (!this.pred) this.items = val.concat(this.items);
      this.pred = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/boots/custom_bootstrap";
.nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $gray-light;
  height: 210px;
  background-color: #fff;
}
.orbit-spinner {
  margin: auto;
}
</style>
